const config = {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:9100',
};

export default config;
